// Canonical job category values stored in DB (PT labels, localised via jobSearch.categories.*)
export const JOB_CATEGORIES = [
  'Tecnologia', 'Saúde', 'Educação', 'Turismo', 'Restauração', 'Construção',
  'Comércio', 'Finanças', 'Marketing', 'Recursos Humanos', 'Administração', 'Engenharia',
  'Eventos', 'Limpeza', 'Segurança', 'Agricultura e Pescas', 'Transportes e Logística',
  'Beleza', 'Imobiliário', 'Indústria', 'Energia e Ambiente', 'Artes e Media',
  'Desporto e Fitness', 'Cuidados Pessoais', 'Jurídico', 'Social e ONG', 'Outro',
];

// job_category slug (business_categories seed) -> job category label
export const JOB_CATEGORY_TO_PT = {
  hospitality: 'Turismo',
  tourism: 'Turismo',
  food_service: 'Restauração',
  retail: 'Comércio',
  construction: 'Construção',
  transport: 'Transportes e Logística',
  logistics: 'Transportes e Logística',
  services: 'Administração',
  healthcare: 'Saúde',
  education: 'Educação',
  beauty: 'Beleza',
  tech: 'Tecnologia',
  cleaning: 'Limpeza',
  events: 'Eventos',
  security: 'Segurança',
  agriculture: 'Agricultura e Pescas',
  real_estate: 'Imobiliário',
  finance: 'Finanças',
  marketing: 'Marketing',
  industry: 'Indústria',
  energy: 'Energia e Ambiente',
  arts_media: 'Artes e Media',
  sports: 'Desporto e Fitness',
  care: 'Cuidados Pessoais',
  legal: 'Jurídico',
  ngo: 'Social e ONG',
  other: 'Outro',
};

export const JOB_CATEGORY_SLUGS = Object.keys(JOB_CATEGORY_TO_PT);
